import React from 'react';
import { string, func } from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  getAuthorName,
  getAuthorIntro,
  getAuthorAvatar,
} from '@blueberry/redux/post';
import styles from './AuthorDetail.scss';

const mapStateToProps = state => ({
  authorName: getAuthorName(state),
  authorIntro: getAuthorIntro(state),
  authorAvatar: getAuthorAvatar(state),
});
function AuthorDetail({ authorName, authorIntro, t, authorAvatar }) {
  return (
    <div className={styles.root}>
      <div className={styles.writtenBy}>{t('post.writtenBy')}</div>

      <img className={styles.avatarImage} src={authorAvatar} alt={authorName} />

      <h2 className={styles.authorName}>{authorName}</h2>
      <p className={styles.detail}>{authorIntro}</p>
    </div>
  );
}
AuthorDetail.propTypes = {
  authorAvatar: string.isRequired,
  authorIntro: string.isRequired,
  authorName: string.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['post']),
  connect(mapStateToProps)
)(AuthorDetail);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/AuthorDetail/AuthorDetail.jsx